import React, { FC } from 'react';
import { StrawStageContent } from '../../../common/model/dto/straw-stage-content';
import OvListTableField from '../atoms/OvListTableField';
import OvListTableButtonField from '../atoms/OvListTableButtonField';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import OvButton from '../atoms/OvButton';
import Colours from '../../../design-system/colours';
import Variables from '../../../design-system/variables';

interface OvStrawStageContentListRowProps {
  strawStageContent: StrawStageContent;
}

const OvStrawStageContentListRow: FC<OvStrawStageContentListRowProps> = ({
  strawStageContent,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <OvListTableField>{strawStageContent.straw_stage}</OvListTableField>
      <OvListTableField>{strawStageContent.cluster}</OvListTableField>
      <OvListTableField>{strawStageContent.name}</OvListTableField>
      <OvListTableField>
        {strawStageContent.predicted_phase_length}
      </OvListTableField>
      <OvListTableButtonField>
        <StyledOvButton>
          <NavLink to={`/straw-stage-contents/${strawStageContent.id}`}>
            {t('common.actions.seeDetails')}
          </NavLink>
        </StyledOvButton>
      </OvListTableButtonField>
    </>
  );
};

export default OvStrawStageContentListRow;

const StyledOvButton = styled(OvButton)`
  && {
    border-radius: ${Variables.borderRadius.CLINIC_DASHBOARD_LARGE};
    padding: 0;
    margin: 0;
    background-color: ${Colours.OV_BASE};

    &:hover {
      a {
        color: ${Colours.OV_BASE};
      }
    }

    a {
      border-radius: ${Variables.borderRadius.CLINIC_DASHBOARD_LARGE};
      padding: 0.25rem 1rem;
      text-decoration: none;
      text-transform: none;
      font-weight: bold;
      font-size: 0.75rem;
      color: ${Colours.OV_WHITE};
    }
  }
`;
